import { Box, Card, Container, Grid, Stack, Typography, styled } from '@mui/material';
import { useLocales } from 'src/locales';

const DATA = [
  { title: '2020', content: ['walkup_lang_029'] },
  { title: '2021', content: ['walkup_lang_030', 'walkup_lang_031'] },
  { title: '2022', content: ['walkup_lang_032', 'walkup_lang_033', 'walkup_lang_034'] },
  {
    title: '2023',
    content: ['walkup_lang_035', 'walkup_lang_036', 'walkup_lang_037', 'walkup_lang_038'],
  },
  {
    title: '2024 - S1',
    content: ['walkup_lang_039', 'walkup_lang_040', 'walkup_lang_041'],
  },
  {
    title: '2024 - S2',
    content: ['walkup_lang_042', 'walkup_lang_043', 'walkup_lang_044', 'walkup_lang_045'],
  },
  {
    title: '2024 - S3',
    content: ['walkup_lang_046', 'walkup_lang_047', 'walkup_lang_048', 'walkup_lang_049'],
  },
  {
    title: '2024 - S4',
    content: ['walkup_lang_050', 'walkup_lang_051', 'walkup_lang_052', 'walkup_lang_053'],
  },
  {
    title: '2025',
    content: ['walkup_lang_054', 'walkup_lang_055', 'walkup_lang_056', 'walkup_lang_057'],
  },
];

const StyledMainDot = styled(Box)(({ theme }) => ({
  width: 20,
  height: 20,
  borderRadius: 999,
  background: theme.palette.primary.main,
}));

const StyledSubDot = styled(Box)(({ theme }) => ({
  width: 20,
  height: 20,
  borderRadius: 999,
  background: theme.palette.primary.main,

  border: '3px solid',
  borderColor: theme.palette.background.paper,

  position: 'relative',

  '&:before': {
    content: `""`,
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: '50%',
    height: '50%',
    transform: 'translate(-50%,-50%)',
    borderRadius: 999,
    background: theme.palette.background.paper,
  },
}));

const StyledDashedLine = styled(Box)(({ theme }) => ({
  flex: 1,
  border: `1px dashed ${theme.palette.primary.main}`,
}));

function HomeRoadmap() {
  const { t } = useLocales();

  return (
    <Container maxWidth="lg">
      <Stack sx={{ py: { xs: 5, md: 10 } }}>
        <Stack sx={{ py: { xs: 5, md: 10 } }}>
          <Typography variant="h2" color="primary" align="center">
            {t('walkup_lang_028')}
          </Typography>
        </Stack>

        <Stack component={Card} p={{ xs: 2, md: 4 }} mt={4}>
          <Grid container spacing={3}>
            {DATA.map((item, j) => {
              const { title, content } = item;

              return (
                <Grid item xs={12} sm={6} md={j > 3 ? 2 : 3}>
                  <Stack>
                    <Grid container>
                      <Grid item xs="auto">
                        <Stack alignItems="center" mr={2} height="100%">
                          <StyledMainDot />
                          <StyledDashedLine />
                        </Stack>
                      </Grid>
                      <Grid item flex={1}>
                        <Box pb={4}>
                          <Typography variant="h4" lineHeight={1}>
                            {title}
                          </Typography>
                        </Box>
                      </Grid>
                    </Grid>

                    {content.map((i, index) => (
                      <Grid container>
                        <Grid item xs="auto">
                          <Stack alignItems="center" mr={2} height="100%">
                            <StyledSubDot />

                            {index + 1 < content.length && <StyledDashedLine />}
                          </Stack>
                        </Grid>
                        <Grid item flex={1}>
                          <Box pb={4}>
                            <Typography variant="body2">{t(i)}</Typography>
                          </Box>
                        </Grid>
                      </Grid>
                    ))}
                  </Stack>
                </Grid>
              );
            })}
          </Grid>
        </Stack>
      </Stack>
    </Container>
  );
}

export default HomeRoadmap;
